/* eslint-disable */
import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class FeedRetriever extends ServiceBase {
  static async followsFeed(limit=10) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/feed?limit=${limit}`;
    const response = await YakFetch.fetch(endpoint, 'GET');
    await FeedRetriever._abortIfUnsuccessful(response);
    const followsFeed = await response.json();
    return followsFeed;
  }
}



// WEBPACK FOOTER //
// ./src/services/feed_retriever.js